"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _pickers = require("@material-ui/pickers");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));

var _TodayOutlined = _interopRequireDefault(require("@material-ui/icons/TodayOutlined"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DefaultKeyboardDatePicker = (0, _styles.withStyles)(() => ({
  root: {
    '& .MuiInputBase-root': {
      border: `1px solid ${_constants.colours.border}`,
      borderRadius: 6
    },
    '& .MuiInputBase-input': {
      height: '44px',
      borderRight: `1px solid ${_constants.colours.border}`,
      padding: '13px 16px',
      boxSizing: 'border-box'
    },
    '& .MuiInputAdornment-root': {
      marginLeft: 0,
      '& .MuiIconButton-root:hover': {
        background: 'none'
      },
      '& .MuiTouchRipple-root': {
        display: 'none'
      }
    },
    '& .MuiIconButton-root': {
      color: `${_constants.colours.font}`
    }
  }
}))(_pickers.KeyboardDatePicker);

const CustomDatePicker = ({
  locale,
  ...rest
}) => /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
  utils: _dateFns.default,
  locale: locale && locale === 'en-GB' && _enGB.default
}, /*#__PURE__*/_react.default.createElement(DefaultKeyboardDatePicker, rest));

CustomDatePicker.defaultProps = {
  keyboardIcon: /*#__PURE__*/_react.default.createElement(_TodayOutlined.default, null),
  disableToolbar: true,
  variant: 'inline',
  margin: 'normal',
  KeyboardButtonProps: {
    'aria-label': 'change date'
  },
  InputProps: {
    disableUnderline: true
  },
  InputLabelProps: {
    shrink: true
  },
  autoOk: true,
  InputAdornmentProps: {
    position: 'end'
  }
};
var _default = CustomDatePicker;
exports.default = _default;